import { useEffect, useRef, useState } from 'react';

/**
 * Reveals text progressively (ChatGPT-style) with an optional blinking cursor.
 */
const TypewriterText = ({
  text,
  active = true,
  charDelayMs = 18,
  onComplete,
  className = '',
}) => {
  const [visible, setVisible] = useState(active ? '' : text);
  const [done, setDone] = useState(!active);
  const indexRef = useRef(0);
  const timerRef = useRef(null);
  const onCompleteRef = useRef(onComplete);

  onCompleteRef.current = onComplete;

  useEffect(() => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (!active) {
      setVisible(text);
      setDone(true);
      return undefined;
    }

    setVisible('');
    setDone(false);
    indexRef.current = 0;

    if (!text) {
      setDone(true);
      onCompleteRef.current?.();
      return undefined;
    }

    const tick = () => {
      indexRef.current += 1;
      const next = text.slice(0, indexRef.current);
      setVisible(next);
      if (indexRef.current >= text.length) {
        setDone(true);
        onCompleteRef.current?.();
        return;
      }
      timerRef.current = window.setTimeout(tick, charDelayMs);
    };

    timerRef.current = window.setTimeout(tick, charDelayMs);

    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, [text, active, charDelayMs]);

  return (
    <span className={className}>
      {visible}
      {active && !done && <span className="lk-typewriter-cursor" aria-hidden />}
    </span>
  );
};

export default TypewriterText;
